<template>
  <div class="md:min-h-screen flex flex-col bg-black text-white">
    <div class="bg-black text-center md:px-24 px-5">
      <div class="font-primary uppercase text-5xl font-medium">
        Einblick ins magazin
      </div>
      <div class="font-primary text-xl mt-10">
        Hier kannst du dir einen kleinen Einblick ins Magazin erhaschen und dir
        einen Eindruck vom Innenteil machen.
      </div>
    </div>

    <div
      class="md:flex-grow relative grid md:custom-rows custom-rows-mobile bg-white mt-8 md:mt-36 md:h-[85vh] h-[35vh]"
    >
      <div class="bg-black rounded-b-[60px] md:rounded-b-[120px]"></div>
      <div class="h-10"></div>
      <div class="bg-grey rounded-t-[60px] md:rounded-t-[120px]"></div>
      <div
        class="absolute inset-0 flex justify-center items-center z-10 overflow-hidden md:h-[85vh] h-[35vh]"
      >
        <img
          class="slide absolute object-cover md:w-[85vw] h-auto w-full md:h-full"
          :class="currentSlide === 0 ? 'opacity-100' : 'opacity-0'"
          src="../assets/imgs/magazine-imgs/img-1.png"
          alt="Magazine Slide"
        />
        <img
          class="slide absolute object-cover md:w-[85vw] h-auto w-full md:h-full"
          :class="currentSlide === 1 ? 'opacity-100' : 'opacity-0'"
          src="../assets/imgs/magazine-imgs/img-2.png"
          alt="Magazine Slide"
        />
        <img
          class="slide absolute object-cover md:w-[85vw] h-auto w-full md:h-full"
          :class="currentSlide === 2 ? 'opacity-100' : 'opacity-0'"
          src="../assets/imgs/magazine-imgs/img-3.png"
          alt="Magazine Slide"
        />
        <img
          class="slide absolute object-cover md:w-[85vw] h-auto w-full md:h-full"
          :class="currentSlide === 3 ? 'opacity-100' : 'opacity-0'"
          src="../assets/imgs/magazine-imgs/img-4.png"
          alt="Magazine Slide"
        />
      </div>
    </div>

    <div class="flex relative space-x-4 w-full justify-center py-4 bg-grey">
      <button
        @click="prevSlide"
        class="px-4 py-2 border md:hover:bg-black md:hover:text-white duration-300 border-black font-primary text-black rounded-full"
      >
        BACK
      </button>
      <button
        @click="nextSlide"
        class="px-4 py-2 border md:hover:bg-black md:hover:text-white duration-300 border-black font-primary text-black rounded-full"
      >
        NEXT
      </button>

    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";

const currentSlide = ref(0);
const slideCount = 4; // Update this if you add more slides

const prevSlide = () => {
  currentSlide.value =
    currentSlide.value === 0 ? slideCount - 1 : currentSlide.value - 1;
};

const nextSlide = () => {
  currentSlide.value =
    currentSlide.value === slideCount - 1 ? 0 : currentSlide.value + 1;
};
</script>

<style scoped>
.custom-rows {
  grid-template-rows: 40% 20% 40%;
}
.custom-rows-mobile {
  grid-template-rows: 48% 5% 48%;
}

.slide {
  transition: opacity 0.5s ease-in-out;
}

.opacity-0 {
  opacity: 0;
}

.opacity-100 {
  opacity: 1;
}
</style>
